import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center p-6 relative z-10">
      <div className="max-w-md w-full text-center bg-[#121212] border border-white/10 p-10 fade-up">
        <XCircle className="text-[#FF3B30] mx-auto mb-6" size={48} />
        <h1 className="font-display font-black text-3xl uppercase tracking-tight mb-2">Checkout canceled</h1>
        <p className="text-white/50 mb-8">No worries — you can start your free trial whenever you're ready.</p>
        <button data-testid="back-to-plans" onClick={() => navigate("/plans")} className="w-full bg-[#FF3B30] hover:bg-[#FF453A] text-white font-bold uppercase tracking-wide px-6 py-3.5 transition-transform duration-150 hover:-translate-y-0.5">
          Back to Plans
        </button>
      </div>
    </div>
  );
}
